import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBarsCafes = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#bars-cafes_svg__a)">
      <path
        fill="#263E6A"
        fillRule="evenodd"
        d="M8.685 6.034a1.893 1.893 0 0 1 2.238 1.557H9.054a.3.3 0 0 0-.298.331l.196 1.859a1.893 1.893 0 0 1-.267-3.747m.33 4.35A2.493 2.493 0 1 1 11.53 7.59h2.409l.667-1.986a.3.3 0 0 1 .402-.18l2.247.96a.3.3 0 0 1-.236.552l-1.948-.833-.5 1.487h.787a.3.3 0 0 1 .299.324l-.834 10.41a.3.3 0 0 1-.299.276h-4.371a.3.3 0 0 1-.298-.269zm2.231-2.193zh2.49l-.903 2.688H9.671L9.387 8.19zm3.124 0-.903 2.688h1.35l.215-2.688zm-1.313 3.288H9.734L10.422 18h3.824l.523-6.522z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="bars-cafes_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBarsCafes;
